import outline from '../layouts/outline'
import defaultLayout from '../layouts/default'
import errors from './errors'
import site from './site'
import user from './user'
import main from './main'
import global from './global'
import mobile from './mobile'
import payment from './main/payment'
import userInfoStatementCcb from './user-info-statement-ccb'

const fallbackRouter = {
  path: '*',
  component: outline,
  children: errors
}

const sharedRouter = {
  path: '/',
  // component: outline,
  component: defaultLayout,
  children: [site, user, main, global, mobile, payment, userInfoStatementCcb]
}
if (__DEV__) {
  // 开发环境，启动项目后，自动跳转登录页
  sharedRouter.children.unshift({
    path: '',
    meta: {
      title: '登录'
    },
    redirect: '/user/login'
  })
}
const routes = [sharedRouter]

// 这个要放在最后
routes.push(fallbackRouter)

export default routes
